var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F9F9F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4814_1864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1867 37.1374H24.5628V44.817C25.1847 44.508 25.8271 44.2028 26.4759 43.8964C27.3786 43.4681 28.2967 43.0334 29.1866 42.5692L29.1867 37.1374ZM22.5932 39.2595V36.1526C22.5932 35.6089 23.0343 35.1678 23.578 35.1678H29.1867V31.6518C29.1867 31.1081 29.6278 30.667 30.1714 30.667H35.7801V28.1281H33.1079C32.9091 28.1243 32.7091 28.064 32.5347 27.9396C32.0949 27.6229 31.9949 27.01 32.3116 26.5701L39.255 16.9222C39.3165 16.8325 39.3947 16.7517 39.4883 16.685C39.9281 16.3683 40.5411 16.4683 40.8578 16.9081L47.7628 26.5022C47.9102 26.6753 48 26.8984 48 27.1433C48 27.687 47.5589 28.1281 47.0152 28.1281H44.3417L44.3391 34.4639C44.343 38.3223 41.7489 41.3521 38.1471 43.5308C33.9848 46.0479 28.2799 47.6301 23.2165 47.6301H16.9848C16.4411 47.6301 16 47.189 16 46.6453V40.2456C16 39.7019 16.4411 39.2608 16.9848 39.2608H22.5935L22.5932 39.2595ZM35.7801 32.6365H31.1562V41.4484C33.7746 39.7955 35.7801 37.6927 35.7801 34.4626V32.6365ZM22.5932 41.2291H17.9693V45.6593H22.5932V41.2291Z",
    fill: "#F70303"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4814_1864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/Growth.40339b89aa1d8b8b3a3ead3a0624e781.svg";
export { ForwardRef as ReactComponent };